export const list = [
  {
    id: '1',
    title: '什么是THE CKB',
    url: 'https://www.theckb.com/about/',
    linkList: [
      {
        label: '最新情報',
        url: 'https://www.theckb.com/news/'
      },
      {
        label: '费率计划',
        url: 'https://www.theckb.com/price/plan/'
      },
      {
        label: '计划诊断',
        url: 'https://www.theckb.com/price/diagnose/'
      },
      {
        label: '国际航运',
        url: 'https://www.theckb.com/price/shipping-fee/'
      }
    ]
  },
  {
    id: '2',
    title: '代购服务',
    url: 'https://www.theckb.com/merchandise/',
    linkList: [
      {
        label: '- 购买现有产品',
        url: 'https://www.theckb.com/merchandise/purchase/'
      },
      {
        label: '- OEM・ODM',
        url: 'https://www.theckb.com/merchandise/oemodm/'
      },
      {
        label: '- FBA直送',
        url: 'https://www.theckb.com/merchandise/fba/'
      }
    ]
  },
  {
    id: '3',
    title: '检验服务',
    url: 'https://www.theckb.com/inspection/',
    linkList: [
      {
        label: '- 检查',
        url: 'https://www.theckb.com/inspection/check/'
      },
      {
        label: '- 维修',
        url: 'https://www.theckb.com/inspection/repair/'
      }
    ]
  },
  {
    id: '4',
    title: '物流服务',
    url: 'https://www.theckb.com/logistics/',
    linkList: [
      {
        label: '- 国际运输',
        url: 'https://www.theckb.com/logistics/shipping/'
      },
      {
        label: '- 仓库储存',
        url: 'https://www.theckb.com/logistics/warehouse/'
      }
    ]
  },
  {
    id: '5',
    title: '促销服务',
    url: 'https://www.theckb.com/promotion/',
    linkList: [
      {
        label: '- 翻译',
        url: 'https://www.theckb.com/promotion/translate/'
      },
      {
        label: '- 照片',
        url: 'https://www.theckb.com/promotion/photo/'
      },
      {
        label: '- 导入文章',
        url: 'https://www.theckb.com/promotion/blog/'
      }
    ]
  },
  {
    id: '6',
    title: '系统',
    url: 'https://www.theckb.com/system/',
    linkList: [
      {
        label: '- 库存系统',
        url: 'https://s.theckb.com/hub/ec'
      },
      {
        label: '- 无库存系统',
        url: 'https://s.theckb.com/hub/ec'
      }
    ]
  },
  {
    id: '7',
    title: '使用流程',
    url: 'https://www.theckb.com/flow/',
    linkList: [
      {
        label: '常问问题',
        url: 'https://www.theckb.com/faq/'
      },
      {
        label: '文件要求',
        url: 'https://www.theckb.com/data/'
      },
      {
        label: '免费注册2',
        url: 'https://www.theckb.com/contact/'
      },
      {
        label: '询问',
        url: 'https://www.theckb.com/contact/'
      }
    ]
  }
]

export const krList = [
  // {
  //   id: '1',
  //   title: '什么是THE CKB',
  //   url: 'https://www.theckbkorea.com/',
  //   linkList: [
  //     {
  //       label: '费率计划',
  //       url: 'https://www.theckbkorea.com/about-1-3'
  //     }
  //   ]
  // },
  // {
  //   id: '2',
  //   title: '代购服务',
  //   url: 'https://www.theckbkorea.com/blog',
  //   linkList: [
  //   ]
  // },
  // {
  //   id: '3',
  //   title: '检验服务',
  //   url: 'https://www.theckbkorea.com/about-1',
  //   linkList: [
  //   ]
  // },
  // {
  //   id: '4',
  //   title: '物流服务',
  //   url: 'https://www.theckbkorea.com/about-1-1',
  //   linkList: [
  //   ]
  // },
  // {
  //   id: '5',
  //   title: '促销服务',
  //   url: 'https://www.theckbkorea.com/about-1-2',
  //   linkList: [
  //   ]
  // },
  {
    id: '6',
    title: '库存系统',
    url: 'https://s.theckb.com/ko/hub/ec',
    linkList: [
      {
        label: '无库存系统',
        url: 'https://s.theckb.com/ko/hub/ec'
      }
    ]
  }
]
export const enList = [
  {
    id: '1',
    title: '什么是THE CKB',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '最新情報',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '费率计划',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '计划诊断',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '国际航运',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '2',
    title: '代购服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 购买现有产品',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- OEM・ODM',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- FBA直送',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '3',
    title: '检验服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 检查',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 维修',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '4',
    title: '物流服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 国际运输',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 仓库储存',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '5',
    title: '促销服务',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 翻译',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 照片',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 导入文章',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  },
  {
    id: '6',
    title: '系统',
    url: 'https://www.theckbofficial.com/',
    linkList: [
      {
        label: '- 库存系统',
        url: 'https://www.theckbofficial.com/'
      },
      {
        label: '- 无库存系统',
        url: 'https://www.theckbofficial.com/'
      }
    ]
  }
]
